module.exports = __webpack_public_path__ + "img/mico-store-finder.0335bd33.jpg";